<template>
  <div class="m-b-1">
    <div class="d-flex ai-center VIDEO-BLOCK">
      <a class="THUMBNAIL" @click="watchVideo(id)">
        <img class="IMG" :src="thumbnail(id)" />
        <div class="CIRCLE"></div>
        <vk-icon
            name="control-play"
            size="32"
            class="PLAY-ARROW c-white"
            unbounded/>
        <div class="VIDEO-LENGTH"> {{ videoList[id].videoLength }}</div>
        <div v-if="isWatched(id)" class="WATCHED-BAR w-100"></div>
      </a>
    </div>
    <div class="d-flex fd-column">
      <green-bubble
          v-if="showViewed"
          bubbleText="Viewed"
          class= "m-r-1 m-b-1"/>
      <div class="VIDEO-TEXT text-bold "> {{ title }}</div>
      <div class="VIDEO-TEXT text-md">{{ videoList[id].videoDescription }}</div>
      <div class="text-sm m-b-1"> {{ created(id) }}</div>
      <button
          @click="goToQuiz(id)"
          v-if="showQuizButton"
          class="btn btn-sm m-b-2 QUIZ-BUTTON">
        Open Quiz
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { formatDistanceToNow } from 'date-fns';
import GreenBubble from '@/views/Dashboard/components/GreenBubble';
import VideoPlaceholder from './VideoPlaceholder';


export default {
  name: 'video-card',
  components: {
    VideoPlaceholder,
    GreenBubble,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    showQuizButton: {
      type: Boolean,
      default: false,
    },
    showViewed: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      expanded: false,
      fetching: false,
    };
  },

  computed: {
    ...mapGetters('account/pro/education', ['videoList', 'videoRecords']),
    title () {
      return this.videoList[this.id].videoTitle;
    },
  },
  methods: {
    ...mapMutations('account/pro/education', ['setVideo']),
    thumbnail (id) {
      return `https://img.youtube.com/vi/${this.videoList[id].youtubeId}/maxresdefault.jpg`;
    },
    created (id) {
      return `Created ${formatDistanceToNow(new Date(this.videoList[id].createdDate))} ago`;
    },
    isWatched (id) {
      return this.videoRecords.find(record => String(record.education_quiz_id) === String(id));
    },
    watchVideo (id) {
      const section = this.videoList[id].videoGroup;
      this.$emit('video-clicked', { videoId: id, group: section });
      this.$events.$emit(
        this.$events.WATCH_VIDEO, {
          videoTitle: this.title,
          section,
        }
      );
      this.$router.replace({
        name: 'dashboard::pro::video',
        params: {
          videoId: id,
        },
      });
    },
    goToQuiz (id) {
      this.setVideo(this.videoList[id]);
      this.$events.$emit(this.$events.OPEN_QUIZ, { openedFrom: 'progress' });
      this.$router.replace({
        name: 'dashboard::pro::quiz',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @keyframes fade-in {
   0%{ opacity: 0;}
   100%{ opacity: 1;}
  }
  .VIDEO-BLOCK{
    margin: 0 $unit $unit 0;
    animation: fade-in 1.0s ;
    display: flex;
    flex-direction: column;

    @include mobile-only {
      margin: 0 0 3 * $unit 0;
    }
    button {
      background: none;
      color: inherit;
      border: none;
      padding: 0;
      outline: none;
    }
  }
  .THUMBNAIL {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    @include mobile-only {
      width: 90vw;
      margin: 0;
    }

  }
  .IMG {
    max-width: 288px;
    @include mobile-only {
      max-width: 90vw;
    }
  }
  .CIRCLE {
    @include square(80px);
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.65);
    position: absolute;
  }
  .PLAY-ARROW  {
    position: absolute;
    justify-self: center;

  }
  .VIDEO-TEXT {
    float: left;
    display: block;
    max-height: 3em;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    @include mobile-only {
      max-width: 90vw;
    }
  }
  .VIDEO-LENGTH {
    font-size: 12px;
    font-weight: 400;
    padding: 0px $unit;
    position: absolute;
    right: $unit;
    bottom: $unit;
    background-color: rgba(0, 0, 0, 0.65);
    color: white;
  }
  .WATCHED-BAR {
    position:absolute;
    bottom:0px;
    height: 4px;
    background-color: $color-depot;
  }
  .QUIZ-BUTTON {
    width: min-content;
  }

</style>
